export const endpoints = {
  REGION_STATISTICS: "/region/statistics",
  REGION_STATISTICS_ORGANIZATIONS_CITIES: "/region/statistics/organizations-cities",
}